// src/lib/asrDraftStorage.ts
export const buildAsrDraftKey = (projectId: string, flagId: string) =>
    `scopeshield:asrDraft:${projectId}:${flagId}`;
